import ENV from "app/utils/ENV";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import chapterHelpers from "app/utils/chapterHelpers";
import valueHelpers from "app/utils/valueHelpers";

let momentHelpers = {
  getStatus(moment, chapter = null) {
    if (!moment) return "open";
    let value = moment.value;
    let isTopic = value?.category == "topic";
    if (isTopic) return "topic";
    let isEvent = value?.category == "event" || value?.category == "narration";
    if (isEvent) return "event";
    let isNote =
      value?.is_note || moment.category == "note" || value.category == "note";
    let isProgressNode = value?.is_progress || moment.category == "progress";
    const shouldCheckProgressWithinChapter = true;
    let wasProgressedTodayWithinChapter = false;
    if (
      shouldCheckProgressWithinChapter &&
      chapter &&
      chapter.range == 1 &&
      !!value?.progress_at?.length
    ) {
      // let wasTodayData = valueHelpers.wasProgressedToday(value, null, true);
      // if (wasTodayData[0]) {
      //   let ts = wasTodayData[1];
      //   if (chapterHelpers.includes(chapter, ts)) {
      //     wasProgressedTodayWithinChapter = true;
      //   }
      // }
      // v don't color just bc the progress_at falls withinthe chapter
      // let progressionsWithinChapter = chapterHelpers.includesProgress(
      //   chapter,
      //   value.progress_at,
      //   true,
      // );
      // wasProgressedTodayWithinChapter = !!progressionsWithinChapter?.length;
    }
    let isProgressedValue =
      (!!value?.id && !value?.completed_at && !!moment?.completed_at) ||
      wasProgressedTodayWithinChapter;
    // let isCompletion = !!value?.completed_at || moment.category == "completion";
    let isCompletion = moment.category == "completion";
    let wasCompletedTodayWithinChapter = false;
    if (chapter && !!value?.completed_at) {
      if (chapterHelpers.includes(chapter, value?.completed_at)) {
        wasCompletedTodayWithinChapter = true;
      }
    }
    if (wasCompletedTodayWithinChapter) isCompletion = true;
    let isCreation = moment.category == "creation";
    let isComposer = moment.composer || moment.category == "composer";

    let isArchived = moment.category == "archive" || !!value?.archived_at;

    if (isComposer) {
      return "composer";
    } else if (moment.category == "placeholder") {
      return "placeholder";
    } else if (isNote) {
      return "note";
    } else if (isProgressNode) {
      return "progress";
    } else if (isProgressedValue) {
      return "progressed_value";
    } else if (isCompletion) {
      return "completion";
    } else if (isArchived) {
      return "archived";
    } else if (isEvent) {
      return "event";
    } else {
      return "open";
    }
  },
  getVersionLines(moment) {
    let snapshotText = !!moment?.snapshot
      ? JSON.parse(moment.snapshot).text || ""
      : undefined;
    let nextSnapshotText = !!moment?.next_snapshot
      ? JSON.parse(moment.next_snapshot).text || ""
      : undefined;
    let currentText = moment?.value?.text;
    let versionLines = [];
    if (snapshotText != undefined && currentText != undefined) {
      // let snapshotLines = snapshotText.split(/[\r\n]/)
      let currentLines = currentText.split(/[\r\n]/);
      currentLines.forEach((line) => {
        if (!!line?.length) {
          if (!snapshotText.includes(line)) {
            if (nextSnapshotText != undefined) {
              // if there is a next snapshot and that one includes this line, then it was added from here
              // compare- if next snapshot doesn't include this line, then this must have been added later on
              if (!!nextSnapshotText.includes(line)) {
                versionLines.push(line);
              }
            } else {
              versionLines.push(line);
            }
          }
        }
      });
    }
    return versionLines;
  },
  getSnapshotLineStatus(line, text, nextText, i) {
    let snapshotStatus = null;
    if (text != undefined) {
      if (!text.includes(line)) {
        if (nextText != undefined) {
          // if there is a next snapshot and that one includes this line, then it was added from here
          // compare- if next snapshot doesn't include this line, then this must have been added later on
          if (!!nextText.includes(line)) {
            snapshotStatus = "added";
          }
        } else {
          snapshotStatus = "added";
        }
      } else if (false && i == 1) {
        // snapshotStatus = "removed";
        // line was in snapshot, but has been removed
      }
    }
    return snapshotStatus;
  },
};

export default momentHelpers;
